import React from 'react'
import DeletedRecordsArchive from '../ManagementDeletedRecordsArchive/ManagementDeletedRecordsArchive'
import EmailAlerts from '../ManagementEmailAlerts/ManagementEmailAlerts'
import SubjectChanges from '../ManagementSubjectChanges/ManagementSubjectChanges'
import ManagementTrackingStats from '../ManagementTrackingStats/ManagementTrackingStats'
import ManagementUserList from '../ManagementUserList/ManagementUserList'

export const returnModalData = (listId, trackData, isEdited, hideModal, userGetData) => {
  let title = ''
  let node = null
  switch (listId) {
    case 'contactSpecs':
      title = 'Contract Specs'
      return { title, node }
    case 'emailAlertManager':
      title = 'Email Alerts Manager'
      node = <EmailAlerts hideModal={hideModal} />
      return { title, node }
    case 'userList':
      title = 'User List'
      node = <ManagementUserList
        trackData={trackData}
        isEdited={isEdited}
        hideModal={hideModal}
        getUserId={userGetData}
      />
      return { title, node }
    case 'trackingStats':
      title = 'Tracking Stats'
      node = <ManagementTrackingStats />
      return { title, node }
    case 'deletedRecordsArchive':
      title = 'Deleted Records Archive'
      node = <DeletedRecordsArchive />
      return { title, node }
    case 'subjectChangesByUser':
      title = 'Subject Changes By User'
      node = <SubjectChanges />
      return { title, node }
    default:
      return { title, node }
  }
}



// WEBPACK FOOTER //
// ./src/components/ManagementTools/helpers.js